import { getRecordTypeName, IntegrationServiceId } from '../../../../common/integrations'
import { AccountIntegrationConfigMappingType, getAccountCRMIntegrationConfig } from '../../../../models/Account'
import { useGetAccountQuery } from '../../../../store/accountUserSettings/accountUserSettings'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../store/hooks'

const CONTACT_MAPPING_LABEL_MAPPING: Record<string, string> = {
  contact: 'Contact',
  account: 'Account',
  plan: 'Plan',
}

export const useContactLabel = (serviceId: IntegrationServiceId) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account } = useGetAccountQuery({ accountId }, { refetchOnMountOrArgChange: false })

  const serviceIntegration = getAccountCRMIntegrationConfig(account?.data, serviceId)
  const entityName = getRecordTypeName(serviceId)
  const contactMapping = serviceIntegration?.mappings[AccountIntegrationConfigMappingType.CONTACT] ?? entityName
  const contactLabel =
    typeof contactMapping === 'string'
      ? CONTACT_MAPPING_LABEL_MAPPING[contactMapping]
      : (contactMapping.displayName ?? CONTACT_MAPPING_LABEL_MAPPING[contactMapping.objectName] ?? 'Contact')

  return { contactLabel: contactLabel ?? 'Contact' }
}
